import { Component, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { AlertComponent, AlertService } from 'cdc-conte-ui-kit';
import { SpinnerComponent } from './components/spinner/spinner';
import { SpinnerService } from './services/spinner-service';
import { RouterServiceConte } from './services/router-service';



@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, AlertComponent, SpinnerComponent ],
  templateUrl: './app.html',
  styleUrl: './app.scss',
})
export class App {
    alertService = inject(AlertService);
    spinnerService = inject(SpinnerService);
    routerService = inject(RouterServiceConte);
    
    constructor() {
      this.routerService.returnCurrentUrl();
    }
    
}
